import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, destinationFor } from "@/context/AuthContext";

// Silently processes the Google OAuth return: exchanges the session_id for a
// session, links any pending Stripe purchase, then routes by entitlement.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogle, linkPurchase } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      const hash = location.hash || (typeof window !== "undefined" ? window.location.hash : "");
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        let me = await exchangeGoogle(sessionId);
        let pending = null;
        try { pending = sessionStorage.getItem("ms_pending_purchase"); } catch (_) {}
        if (pending) {
          try { me = await linkPurchase(pending); } catch (_) { /* unpaid or already claimed */ }
          try { sessionStorage.removeItem("ms_pending_purchase"); } catch (_) {}
        }
        try { sessionStorage.removeItem("ms_auth_intent"); } catch (_) {}

        const dest = destinationFor(me);
        if (dest) {
          navigate(dest, { replace: true });
        } else {
          toast.error("No active The Paycheck Edit found for this account. Purchase to get access.");
          navigate("/", { replace: true });
        }
      } catch (_) {
        toast.error("Sign-in didn't complete. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF8F4]" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-9 w-9 animate-spin rounded-full border-2 border-[#E5E0D9] border-t-[#2F6B57]" />
        <p className="mt-5 text-[15px] text-[#525252]">Finishing sign-in…</p>
      </div>
    </div>
  );
}
